import React from 'react'
import { useNavigate } from 'react-router-dom'
import GardenDailyWorkCard from './GardenDailyWork'
import { Pie } from 'react-chartjs-2'
import { Pieoptions } from '../../../../../Helper/Data'
import { useAuthState } from '../../../../../Helper/Context'

export default function GardenDailyWorkCardManage(props) {

    const { Countdata, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName } = props
    const navigate = useNavigate()

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token, RoleID } = userDetails.user


    const DailyPreventiveWorkNavigate = (name, screenFlag) => {
        if (name === "Pending") {
            navigate(`/gardenworkpending?name=${name}&ApiFlag=Pending&Year=${year?.ID}&YLable=${year?.Label}&Month=${Month?.ID}&MLable=${Month?.Label}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Completed") {
            navigate(`/gardenworkpending?name=${name}&ApiFlag=Completed&Year=${year?.ID}&YLable=${year?.Label}&Month=${Month?.ID}&MLable=${Month?.Label}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        }
    }

    const Receiveddata = {
        labels: ["Pending", "Completed",],
        datasets: [
            {
                label: '# of Votes',
                data: [
                    Countdata && Countdata?.PreventivePendingTotalCount,
                    Countdata && Countdata?.PreventiveCompletedTotalCount
                    // 50,20
                ],
                backgroundColor: [
                    "#ffc33d",
                    "#f48242"
                ],
                borderColor: [
                    // '#28c8c1',
                    // '#172b4d',
                    // '#993366',
                    // '#593e89',
                    // '#94408e',
                    // '#c74382',
                    // '#fa5d00',
                    // '#529ad2',
                    // '#ffc137',
                ],
                borderWidth: 1,
            },
        ],
    };

    return (
        // <>

        // </>
        <div className='row mx-0 p-0   ' >

            <h5 className=" pt-2 mb-0 mx-0">Daily Preventive Work</h5>
            <div className='m-0' > <hr className="mt-2" style={{ color: "#a3964e" }}></hr></div>

            <div className="row g-3 m-0">


                <div className="col-12 col-lg-7 px-3 ">
                    <div className=" rounded-4    p-0 h-100">

                        <div className="row g-3    " style={{ borderRadius: "8px" }}>

                            <div className="col-12 col-md-6 mt-0 mb-0       ">
                                <GardenDailyWorkCard
                                    title="Completed"
                                    cardName='py-2 wwork_img cursor'
                                    imgPath='./assets/img/completed1.png'
                                    count={
                                        Countdata.PreventiveCompletedTotalCount
                                            ? Countdata.PreventiveCompletedTotalCount
                                            : '0'
                                    }
                                    DailyPreventiveWorkNavigate={DailyPreventiveWorkNavigate}
                                />
                            </div>

                            <div className="col-12 col-md-6  mt-0 ">
                                <GardenDailyWorkCard
                                    title="Pending"
                                    cardName='py-2 wwork_img cursor'
                                    imgPath='./assets/img/pending.png'
                                    count={
                                        Countdata.PreventivePendingTotalCount
                                            ? Countdata.PreventivePendingTotalCount
                                            : '0'
                                    }
                                    DailyPreventiveWorkNavigate={DailyPreventiveWorkNavigate}
                                />
                            </div>

                        </div>

                    </div>
                </div>


                <div className="col-12 col-lg-5 mt-0 ps-3 pe-1">
                    <div className=" rounded-4 shadow-sm p-3 pt-2 mt-0 h-100 Chartborder ">

                        <div className="d-flex justify-content-center align-items-center h-100 ">

                            {(Countdata?.PreventivePendingTotalCount != 0) ||
                                (Countdata?.PreventiveCompletedTotalCount != 0) ? (

                                <Pie
                                    height={120}
                                    options={Pieoptions}
                                    data={Receiveddata}
                                />

                            ) : (

                                <div className='text-danger  my-auto align-item-center  justify-content-center fw-bolder' style={{ height: '7vh', }}>
                                    <img
                                        className='wwork_img me-3'
                                        src="../assets/img/bar-graph.png"
                                    />
                                    <span className=''>No Data Found</span>
                                </div>
                            )}

                        </div>

                    </div>
                </div>

            </div>
        </div>
    )

}

